module.exports = __webpack_public_path__ + "static/media/Icon feather-clock.bf6e4274.svg";